import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl border border-slate-200 overflow-hidden" }
const _hoisted_2 = { class: "lg:hidden mt-4 text-center" }
const _hoisted_3 = { class: "text-xs text-slate-500" }
const _hoisted_4 = { class: "font-semibold text-slate-700" }

import {  ref } from "vue";

import SkeletonTablas from "@/share/components/SkeletonTablas.vue";
import ErrorState from "@/share/components/ErrorState.vue";
import PaginationCompontens from "@/share/components/PaginationCompontens.vue";
import { gpedPedidosPaginacionFilterParams } from "../interfaces/gpedPedidosPaginacionFilterParams";
import { applyPedidosSortField, usePedidosList } from "../composables";
import PedidosCompletadosTable from "../components/pedidosCompletadosComponents/pedidosCompletadosTable.vue";
import PedidosFiltros from "@/share/components/PedidosFiltros.vue";
import EmptyStatePedidos from "@/share/components/EmptyStatePedidos.vue";
import { useGeneratePedidoPdf } from "../composables/useGeneratePedidoPdf";
import PedidoDetallesModal from "@/share/components/PedidoDetallesModal.vue";
import AdminPageShell from "@/share/components/admin/AdminPageShell.vue";

// Estado de filtros y paginación

export default /*@__PURE__*/_defineComponent({
  __name: 'PedidosCompletadosView',
  setup(__props) {

const params = ref<gpedPedidosPaginacionFilterParams>({
  page: 1,
  limit: 10,
  search: "",
  estadoNombre: "Completado",
  sortBy: "createdAt",
  sortOrder: "desc",
});
const selectedPedidoId = ref("");
const isModalOpen = ref(false);
// Hook de pedidos
const {
  pedidos,
  total,
  totalPages,
  currentPage,
  isPending: isLoadingList,
  isError,
  error,
  refetch,
} = usePedidosList(params);

const { mutate: generatePdf } = useGeneratePedidoPdf();

// Handlers de búsqueda y filtros
const handleSearch = (search: string) => {
  params.value.search = search;
  params.value.page = 1;
};

const handlePageChange = (page: number) => {
  params.value.page = page;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const handleLimitChange = (limit: number) => {
  params.value.limit = limit;
  params.value.page = 1;
};

const handleSort = (field: string) => {
  applyPedidosSortField(params, field);
};


// Acciones de pedidos
const handleViewDetails = (pedidoId: string) => {
  selectedPedidoId.value = pedidoId;
  isModalOpen.value = true;
};
const handleUpdateEstado = (_pedidoId: string) => {
  // Los pedidos completados son el estado final; no hay transición disponible
};

const handleDescargarPDF = (pedidoId: string) => {
  generatePdf(pedidoId);
};

const handleCloseModal = () => {
  isModalOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminPageShell, {
    title: "Pedidos completados",
    description: "Historial de pedidos en estado Completado."
  }, {
    default: _withCtx(() => [
      _createVNode(PedidoDetallesModal, {
        "pedido-id": selectedPedidoId.value,
        "is-open": isModalOpen.value,
        onClose: handleCloseModal
      }, null, 8, ["pedido-id", "is-open"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PedidosFiltros, {
          params: params.value,
          total: _unref(total),
          onSearch: handleSearch,
          onLimitChange: handleLimitChange
        }, null, 8, ["params", "total"]),
        (_unref(isLoadingList))
          ? (_openBlock(), _createBlock(SkeletonTablas, { key: 0 }))
          : (_unref(isError))
            ? (_openBlock(), _createBlock(ErrorState, {
                key: 1,
                error: _unref(error),
                onRetry: _unref(refetch)
              }, null, 8, ["error", "onRetry"]))
            : (_unref(pedidos).length === 0)
              ? (_openBlock(), _createBlock(EmptyStatePedidos, { key: 2 }))
              : (_openBlock(), _createBlock(PedidosCompletadosTable, {
                  key: 3,
                  pedidos: _unref(pedidos),
                  sortField: params.value.sortBy ?? 'createdAt',
                  sortDirection: params.value.sortOrder ?? 'desc',
                  currentPage: _unref(currentPage),
                  pageSize: params.value.limit,
                  onSort: handleSort,
                  onViewDetails: handleViewDetails,
                  onUpdateEstado: handleUpdateEstado,
                  onDescargarPdf: handleDescargarPDF
                }, null, 8, ["pedidos", "sortField", "sortDirection", "currentPage", "pageSize"])),
        (!_unref(isLoadingList) && !_unref(isError) && _unref(total) > 0)
          ? (_openBlock(), _createBlock(PaginationCompontens, {
              key: 4,
              "current-page": _unref(currentPage),
              "total-pages": _unref(totalPages),
              total: _unref(total),
              limit: params.value.limit,
              onPageChange: handlePageChange
            }, null, 8, ["current-page", "total-pages", "total", "limit"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _cache[0] || (_cache[0] = _createTextVNode(" Total de pedidos: ", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(total)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})